import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const emptyState = {
  name: "",
  segmentId: "",
  active: true
};

const SubsegmentModal = ({ open, onClose, subsegmentId, onSave }) => {
  const [record, setRecord] = useState(emptyState);
  const [segments, setSegments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    const loadSegments = async () => {
      try {
        const { data } = await api.get("/segments");
        setSegments((Array.isArray(data?.segments) ? data.segments : []).filter(item => item && typeof item === "object" && item.id != null));
      } catch (err) {
        toastError(err);
      }
    };

    loadSegments();
  }, [open]);

  useEffect(() => {
    if (!open) return;

    if (!subsegmentId) {
      setRecord(emptyState);
      return;
    }

    const loadRecord = async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/subsegments/${subsegmentId}`);
        setRecord({
          name: data.name || "",
          segmentId: data.segmentId || "",
          active: data.active !== false
        });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        toastError(err);
      }
    };

    loadRecord();
  }, [open, subsegmentId]);

  const handleSave = async () => {
    try {
      if (!record.name || !record.name.trim()) {
        toast.error("Nome é obrigatório");
        return;
      }

      if (!record.segmentId) {
        toast.error("Segmento é obrigatório");
        return;
      }

      setLoading(true);

      const payload = {
        ...record,
        segmentId: Number(record.segmentId)
      };

      if (subsegmentId) {
        await api.put(`/subsegments/${subsegmentId}`, payload);
        toast.success("Subsegmento atualizado com sucesso");
      } else {
        await api.post("/subsegments", payload);
        toast.success("Subsegmento criado com sucesso");
      }

      setLoading(false);
      onSave && onSave();
      onClose();
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{subsegmentId ? "Editar Subsegmento" : "Novo Subsegmento"}</DialogTitle>

      <DialogContent dividers>
        <FormControl fullWidth style={{ marginBottom: 16 }}>
          <InputLabel>Segmento</InputLabel>
          <Select
            value={record.segmentId}
            onChange={(e) => {
              const value = e.target.value;
              setRecord(prev => ({ ...prev, segmentId: value }));
            }}
            disabled={loading}
          >
            <MenuItem value=""><em>Selecione</em></MenuItem>
            {segments.filter(item => item && typeof item === "object" && item.id != null).map(item => (
              <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Nome"
          value={record.name}
          onChange={(e) => {
            const value = e.target.value;
            setRecord(prev => ({ ...prev, name: value }));
          }}
          disabled={loading}
        />

        <FormControlLabel
          style={{ marginTop: 16 }}
          control={
            <Switch
              checked={record.active}
              onChange={(e) => {
                const checked = e.target.checked;
                setRecord(prev => ({ ...prev, active: checked }));
              }}
              color="primary"
              disabled={loading}
            />
          }
          label="Ativo"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button color="primary" variant="contained" onClick={handleSave} disabled={loading}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubsegmentModal;
